<template>
  <div
    :class="[{ active: item.active }, 'vue-grid-item__wrapper']"
    @click="setActiveChart(item)"
  >
    <div class="vue-grid-item__header">
      <el-popover
        placement="bottom-start"
        popper-class="r-popover charts-type-switcher-popover"
        :visible-arrow="false"
        v-model="isPopoverShow"
      >
        <charts-type-switcher :item="item" />
        <div
          slot="reference"
          :class="[
            'charts-type-switcher-popover-reference',
            { active: isPopoverShow }
          ]"
        >
          <r-icon
            :name="item.type"
            :size="24"
            style="cursor: pointer"
            arrow-down
          />
        </div>
      </el-popover>
      <div class="vue-grid-item__header-title">
        <r-text>{{ getChartName(item.i) }}</r-text>
      </div>
      <div class="vue-grid-item__header-buttons" style="margin-left: auto">
        <el-dropdown
          class="r-dropdown"
          size="mini"
          :show-timeout="100"
          placement="bottom-start"
          trigger="click"
          @visible-change="e => toggleHandler(e)"
        >
          <div :class="['r-dropdown__item', { active: isDropdownShow }]">
            <r-icon
              name="other-actions"
              :size="24"
              style="cursor:pointer;padding:6px"
            />
          </div>
          <el-dropdown-menu slot="dropdown" class="r-dropdown-menu">
            <el-dropdown-item v-for="action in actionsList" :key="action.id">
              <div
                class="r-dropdown-menu__item-wrapper"
                @click="clickHandler(action.name, item)"
              >
                <r-icon
                  :name="action.icon"
                  :size="20"
                  :color-type="action.colorType"
                />
                <r-text :color-type="action.colorType" style="margin-left:4px">
                  {{ $t(action.name) }}
                </r-text>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="vue-grid-item__content">
      <chartBuild :chart-type="item.type" :id="item.i" />
    </div>
  </div>
</template>

<script>
import chartBuild from "../chart-build.vue";
import chartsTypeSwitcher from "../options/charts-type-switcher";
import { actionsList } from "./config/";
import { generateUUID } from "@/utils";

export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },
  components: {
    chartBuild,
    chartsTypeSwitcher
  },
  data() {
    return {
      isPopoverShow: false,
      isDropdownShow: false,
      actionsList
    };
  },
  methods: {
    toggleHandler(val) {
      this.isDropdownShow = val;
    },
    clickHandler(action) {
      switch (action) {
        case "export":
          break;
        case "duplicate":
          this.duplicateChart(this.item);
          break;
        case "delete":
          this.closeWindow(this.item);
          break;
        default:
          return;
      }
    },
    setActiveChart(chart) {
      if (chart.i !== Object.keys(this.$store.state.charts.activeChart)[0]) {
        this.$store.commit("SET_ACTIVE_CHART", chart);
      }
    },
    async closeWindow(item) {
      this.$store.commit("CLOSE_CHART", { id: item.i, tab: item.tab });
      await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    getChartName(id) {
      const chartData = this.$store.state.charts.chartsData[id];

      return chartData
        ? chartData.name || chartData.title
        : this.$t("chart-window:title");
    },
    async duplicateChart(item) {
      const chartId = generateUUID();

      let activeTab = this.$store.state.charts.activeTab.tab;
      if (!activeTab) {
        activeTab = 1;
        this.$store.commit("ADD_CHART_TAB", activeTab);
      }
      const chartsLayouts = this.$store.state.charts.chartsLayouts;
      const activeTabLayout = chartsLayouts[activeTab];
      if (activeTabLayout.length > 2) {
        activeTab = Math.max(...Object.keys(chartsLayouts)) + 1;
        this.$store.commit("ADD_CHART_TAB", activeTab);
      }
      this.$store.commit("ADD_NEW_CHART", {
        id: chartId,
        type: item.type,
        tab: activeTab
      });
      this.$store.commit("CHARTS_DUPLICATE", {
        duplicatorId: item.i,
        newId: chartId
      });

      try {
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss">
.charts-type-switcher-popover {
  padding: 0 !important;
  &-reference {
    padding: 6px;
    border-radius: var(--border-radius);
    &.active {
      background-color: var(--accent_selected) !important;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "chart-window:title": "Название графика",
    "export": "Экспортировать",
    "duplicate": "Дублировать",
    "delete": "Удалить"
  },
  "en": {
    "chart-window:title": "Chart title",
    "export": "Export",
    "duplicate": "Duplicate",
    "delete": "Delete"
  }
}
</i18n>
